<template>
    <section class="media-card-list u-mt-2xl" v-if="data && data.length">
        <media-card
            v-for="dataItem in data"
            :label="dataItem.name"
            :date="dataItem.activeFrom"
            :href="dataItem.sectionPageUrl"
            :image="dataItem.image.link"
        />
    </section>
</template>

<script setup>
import MediaCard from './MediaCard.vue';

const {data} = defineProps({
    data: {
        type: Array
    }
})
</script>

<style lang="scss">
.media-card-list {
    $parent: &;

    display: grid;
    grid-template-columns: repeat(3, 1fr);

    gap: var(--spacer-m);

    @include breakpoint(tablet) {
        grid-template-columns: repeat(2, 1fr);
    }

    @include breakpoint(mobile) {
        grid-template-columns: 1fr;
    }
}
</style>
